import { TEACHER_DEPARTMENT_NAME } from './constants';

// Which department a reminder files under, given who is on it. The assignee owns the
// reminder so their department wins; otherwise the first observer who has one, then the
// creator's. Returns '' when nobody on the reminder has a department to offer.
//
// Teachers hold no department of their own, so a teacher-owned reminder files under the
// one named TEACHER_DEPARTMENT_NAME, looked up by name because the uuid differs per
// environment. A Care-member assignee uses their own department instead, same as an
// observer or the creator would.
export const derive_department_uuid = ({
  assignee_uuid,
  observer_uuids,
  member_by_uuid,
  departments,
  self_uuid
}) => {
  if (assignee_uuid) {
    const assignee = member_by_uuid(assignee_uuid);
    if (!assignee || assignee.kind === 'teacher') {
      return (departments || []).find((d) => d.name === TEACHER_DEPARTMENT_NAME)?.uuid || '';
    }
    if (assignee.department_uuid) return assignee.department_uuid;
  }
  const observer = (observer_uuids || [])
    .map((uuid) => member_by_uuid(uuid))
    .find((m) => m?.department_uuid);
  return observer?.department_uuid || member_by_uuid(self_uuid)?.department_uuid || '';
};
